export const InputBase = {
    inheritAtts: false,
    functional: true,
    props: {
        textarea: Boolean,
        label: String,
    },
    render(createElement, {props, data, slots}) {
        let Tag = props.textarea ? 'textarea' : 'input';

        return (
            <div class="input-block">
                <Tag class="input-block__input" {...data}/>
                {props.label ? (
                    <label class="label input-block__label" for="">{props.label}</label>
                ) : null}
                {slots().after}
            </div>
        );
    }
}
